import { Mail, MapPin, Phone } from "lucide-react";
import { Eyebrow, MaskLine, Reveal } from "@/components/site/Reveal";
import { ContactForm } from "@/components/site/ContactForm";
import { CONTACT } from "@/lib/api";

export function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="relative bg-obsidian py-24 md:py-36">
      <div className="mx-auto grid max-w-[1500px] gap-14 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Eyebrow>Contact / Location</Eyebrow>
          <h2 className="mt-5 font-display text-[12.5vw] sm:text-6xl md:text-8xl font-black uppercase leading-[0.85]" style={{ fontWeight: 900 }}>
            <MaskLine inView>Let's cut</MaskLine>
            <MaskLine inView delay={0.1}><span className="text-volt">to it.</span></MaskLine>
          </h2>
          <Reveal className="mt-10 space-y-5">
            <a href={CONTACT.phoneHref} data-testid="contact-phone-link" className="group flex items-center gap-4 border-b border-white/10 pb-5">
              <Phone className="h-5 w-5 text-volt" />
              <span className="font-display text-3xl font-bold group-hover:text-volt transition-colors">{CONTACT.phone}</span>
            </a>
            <a href={`mailto:${CONTACT.email}`} data-testid="contact-email-link" className="group flex items-center gap-4 border-b border-white/10 pb-5">
              <Mail className="h-5 w-5 text-volt" />
              <span className="font-display text-2xl md:text-3xl font-bold group-hover:text-volt transition-colors break-all">{CONTACT.email}</span>
            </a>
            <div data-testid="contact-location" className="flex items-center gap-4 border-b border-white/10 pb-5">
              <MapPin className="h-5 w-5 text-volt" />
              <span className="font-display text-2xl md:text-3xl font-bold">{CONTACT.location}</span>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="mt-8">
            <div className="clip-notch relative aspect-[16/10] overflow-hidden border border-white/10">
              <iframe
                title="Grand Rapids, Michigan map"
                data-testid="contact-map"
                src="https://maps.google.com/maps?q=Grand%20Rapids%2C%20MI&z=11&output=embed"
                className="absolute inset-0 h-full w-full"
                style={{ filter: "grayscale(1) invert(0.92) contrast(1.1)" }}
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.1} className="lg:col-span-7 lg:pl-10">
          <div className="border border-white/10 bg-surface p-6 md:p-12">
            <p className="mb-8 max-w-lg text-zinc-300">Department orders, demos, specs or a custom quote. Drop us a line and the BAMF crew will get back to you.</p>
            <ContactForm />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
